import React, { Fragment, useMemo } from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";

const ResearcherProjectField = ({ record }) => {
  const { executiveProject, researchProject } = useMemo(() => {
    const executiveProject = get(record, "user.executive_project", null);
    const researchProject = get(executiveProject, "research_project");
    return { executiveProject, researchProject };
  }, [record]);
  return (
    <Fragment>
      <Typography>{executiveProject?.public_operative_unit}</Typography>
      <Typography variant="body2">{researchProject?.full_title}</Typography>
    </Fragment>
  );
};
export default ResearcherProjectField;
